<div class="flex flex-col mt-6 justify-center items-center">
  <img
    src="../../../assets/img/404-error.webp"
    class="w-1/3"
    width="10"
    height="20"
    alt="error-404"
    loading="lazy"
  />
  <p class="sm:text-3xl text-xl text-black font-extrabold m-2 text-center">
    محتوایی برای نمایش وجود ندارد
  </p>
  <div class="m-2 text-center">
    <p>صفحه ای که به دنبال آن میگردید میتواند پاک شده</p>
    <p>یا اسم آن تغییر یافته یا موقتا در دسترس نباشد</p>
  </div>
  <div class="flex items-center mt-8 flex-wrap">
    <a href="https://www.iraniexpert.com" target="_blank" class="btn-erorr-3"><p class="font-bold text-[#3246d3]">خانه</p></a>
    <a href="https://www.iraniexpert.com/shop" target="_blank" class="btn-erorr-2"><p class="font-bold text-[#767676]">فروشگاه</p></a>
    <a href="https://www.iraniexpert.com/economic-calendar" target="_blank" class="btn-erorr-1"><p class="font-bold text-[#098b41]">تقویم اقتصادی</p></a>
  </div>
</div>